// NHBSubsidy.js
import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";
import { FaAngleRight } from "react-icons/fa";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema } from "../../Schemas/Enquiry/enquiry_schema";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { useState } from "react";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useEffect } from "react";

const NHBSubsidy = () => {
  const { state, city } = useParams();
  const [loading, setLoading] = useState(false);
  const [district, setDistrict] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/subsidy/get-district/?state=${state}`)
      .then((res) => {
        if (res.status === 201) {
          const first15Districts = res.data
            .slice(0, 15)
            .map((d) => d.toLowerCase());

          setDistrict(first15Districts);
        } else {
          Toast("error", "Error while getting application!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [state]);

  const handelSubmit = (values, actions) => {
    values = { ...values, origin: "NHB-Alpha" };

    // const formData = new FormData();

    // for (let key in values) {
    //   if (values[key] instanceof File || values[key] instanceof Blob) {
    //     formData.append(key, values[key]);
    //   } else if (typeof values[key] === "object" && values[key] !== null) {
    //     formData.append(key, JSON.stringify(values[key]));
    //   } else {
    //     formData.append(key, values[key]);
    //   }
    // }

    // const headers = { "content-type": "multipart/form-data" };
    setLoading(true);
    performRequest("POST", "/enquiryWebhook/createEnquiry/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Enquiry Created Cuccessfully!");
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div>
      <Helmet>
        <title>
          NHB Hydroponic Subsidy in {city}, {state} | 50% Support for Modern
          Farming
        </title>
        <meta
          name="description"
          content={`Farmers in ${city}, ${state} can apply for the NHB government subsidy to set up hydroponic and protected cultivation projects. Get up to 50% financial support for greenhouses, polyhouses, and sustainable farming.`}
        />
        <meta
          name="keywords"
          content={`
      NHB hydroponic subsidy in ${city}, 
      NHB hydroponic subsidy in ${state}, 
      Hydroponic subsidy ${city}, 
      Hydroponic subsidy ${state}, 
      Protected cultivation subsidy ${city}, 
      Protected cultivation subsidy ${state}, 
      Greenhouse subsidy ${city}, 
      Greenhouse subsidy ${state}, 
      NHB scheme ${city}, 
      NHB scheme ${state}, 
      Kryzen Biotech NHB subsidy ${city}, 
      Kryzen Biotech NHB subsidy ${state}
    `}
        />
        <meta
          property="og:title"
          content={`NHB Subsidy in ${city}, ${state}`}
        />
        <meta
          property="og:description"
          content={`Apply for NHB goverment subsidy in ${city}, ${state}. Free consultation & quick approval assistance.`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://alpha.kryzen.com/nhb-government-subsidy/${state}/${city}`}
        />
        <link
          rel="canonical"
          href={`https://alpha.kryzen.com/nhb-government-subsidy/${state}/${city}`}
        />
      </Helmet>

      <div className="px-3 px-md-8 ms-md-8 me-md-8  py-4">
        <h1
          className="text-center fw-bold text-uppercase"
          style={{ fontSize: "2.2rem" }}
        >
          NHB Goverment Subsidy in {city}, {state}!
        </h1>
        <hr></hr>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="p-1 p-md-2">
              {/* Content Section */}
              <div className="">
                <h2 className="lh-lg fs-1 text-center">
                  <p className="fs-2 lh-lg">
                    The{" "}
                    <strong>National Horticulture Board (NHB) subsidy</strong>{" "}
                    supports farmers, agri-entrepreneurs, and startups in
                    protected cultivation and hydroponics. In Maharashtra,
                    including cities like <strong>Pune</strong> and{" "}
                    <strong>Nashik</strong>, growers can receive financial aid
                    for{" "}
                    <strong>
                      hydroponics, polyhouses, shade nets, and drip irrigation
                    </strong>
                    .<strong>Kryzen Biotech</strong> helps farmers access NHB
                    subsidies with expert guidance in planning, documentation,
                    and execution. We specialize in{" "}
                    <strong>hydroponic farming solutions</strong> that ensure
                    higher productivity and sustainable agriculture. Partner
                    with Kryzen Biotech to make your modern farming project
                    profitable and subsidy-ready.
                  </p>
                </h2>
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844978/3_vgyqbp.jpg"
                  alt="middle img"
                  className="w-100 my-3"
                />
                <p className="fs-2 lh-lg mt-5">
                  {" "}
                  Hydroponics is a soilless farming technique that ensures
                  higher yields, faster crop cycles, and better quality produce
                  compared to traditional farming. The NHB subsidy makes it
                  financially viable for small and medium farmers to adopt
                  hydroponics by covering <strong>35% to 50%</strong> of the
                  project costs, with higher benefits available for women
                  farmers, Scheduled Castes, and Scheduled Tribes.
                </p>{" "}
                <p className="fs-2 lh-lg">
                  For farmers in <strong>{state}</strong>, the NHB subsidy plays
                  a crucial role in reducing risks associated with unpredictable
                  weather, rising input costs, and limited fertile land. Cities
                  like <strong>{city}</strong> and Pune have seen growing
                  interest in urban hydroponics and rooftop farming, where the
                  NHB scheme has been instrumental in supporting projects.
                </p>
                <p className="fs-2 lh-lg">
                  Beyond financial aid, NHB also offers{" "}
                  <strong>technical guidance</strong>, capacity-building
                  workshops, and farmer training programs. These initiatives
                  help farmers optimize resource use, maintain correct pH and EC
                  levels, and adopt best practices in nutrient management. With{" "}
                  {state} being one of the leading horticultural states in
                  India, the NHB subsidy ensures that modern farming
                  technologies are accessible to grassroots farmers.
                </p>
                <p className="fs-2 lh-lg">
                  If you are a farmer, agri-startup, or entrepreneur in {state}
                  looking to set up a hydroponics project in{" "}
                  <strong>{city}</strong> or any other district, applying for
                  the NHB subsidy can drastically reduce your investment burden.
                  Our team at <strong>Kryzen Biotech</strong> specializes in
                  subsidy consultation, project design, and turnkey
                  implementation.
                </p>
                {/* <p className="fs-2 lh-lg">
                  In conclusion, the <strong>NHB Hydroponic Subsidy</strong> is
                  a game-changer for farmers in {state}. Whether you are based
                  in urban areas like {city} or agricultural belts like Nashik,
                  the NHB subsidy opens doors to future-ready farming that is
                  efficient, scalable, and profitable.
                </p> */}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 mt-4 mt-md-5 p-3 border d-flex flex-column  align-items-center">
            {/* Form Section */}
            <div>
              <Formik
                initialValues={enquiryInfo}
                validationSchema={enquirySchema}
                onSubmit={handelSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form
                    className="card p-3 p-md-5 bg-green-lt"
                    // style={{ backgroundColor: "lightgreen" }}
                  >
                    <h2
                      className="fs-2 fs-md-3 text-center mb-3"
                      style={{ color: "black" }}
                    >
                      Join an expert call for national horticulture board (NHB)
                      subsidy in {city}, {state}
                    </h2>
                    <hr></hr>
                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        First Name
                      </label>
                      <CustomInput name="firstName" type="text" />
                      {props.touched.firstName && props.errors.firstName && (
                        <p className="text-danger">{props.errors.firstName}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Last Name
                      </label>
                      <CustomInput name="lastName" type="text" />
                      {props.touched.lastName && props.errors.lastName && (
                        <p className="text-danger">{props.errors.lastName}</p>
                      )}
                    </div>

                    {/* <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Full Name
                      </label>
                      <CustomInput name="fullName" type="text" />
                      {props.touched.fullName && props.errors.fullName && (
                        <p className="text-danger">{props.errors.fullName}</p>
                      )}
                    </div> */}

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Mobile Number
                      </label>
                      <CustomInput name="mobileNumber" type="text" />
                      {props.touched.mobileNumber &&
                        props.errors.mobileNumber && (
                          <p className="text-danger">
                            {props.errors.mobileNumber}
                          </p>
                        )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" style={{ color: "black" }}>
                        Email
                      </label>
                      <CustomInput name="email" type="text" />
                      {props.touched.email && props.errors.email && (
                        <p className="text-danger">{props.errors.email}</p>
                      )}
                    </div>

                    <div className="text-center mt-3">
                      {/* <FormSubmitButton buttonText="Submit" /> */}
                      <button
                        class="btn btn-github  btn mx-1 mt-2 text-center"
                        isSubmitting={props.isSubmitting}
                      >
                        <BsBoxArrowInRight className="fs-2 me-2"></BsBoxArrowInRight>
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div className="">
              <img
                className="w-100"
                style={{ height: "720px" }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/sidebar_id3qyb.jpg"
                alt="conditions img"
              />
            </div>
          </div>
        </div>

        {/* Conditions Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/subsidy_conditions_u2p8a1.jpg"
              alt="benefits img"
            />
          </div>
          <div className="col-12 col-md-8 ps-md-2 ">
            <h2 className="fw-bold mb-3 text-uppercase fs-1 mt-5 mt-md-0 mt-lg-0">
              NHB Subsidy Conditions
            </h2>
            <hr></hr>
            <p className="mt-4 fs-2 lh-lg">
              The <b>National Horticulture Board (NHB)</b> subsidy scheme is
              designed to promote protected cultivation and modern horticulture
              practices across India. Through structured financial support, it
              enables farmers and entrepreneurs to adopt polyhouses,
              greenhouses, and other advanced technologies that increase
              productivity and ensure sustainable farming. Kryzen Biotech plays
              a vital role in assisting farmers with project planning, subsidy
              application, technical guidance, and end-to-end execution—helping
              them maximize the benefits of NHB support while building
              long-lasting and profitable agri-infrastructure.
            </p>
            <ol className="fs-2 lh-lg ">
              <li>
                <strong>Eligibility:</strong> Farmers, FPOs, SHGs, NGOs, and
                agri-entrepreneurs with valid land ownership or lease.
              </li>
              <li>
                <strong>Area Limit:</strong> Minimum project size as per NHB
                guidelines, maximum up to{" "}
                <strong>4000 sq. m. per beneficiary</strong>.
              </li>
              <li>
                <strong>Technical Standards:</strong> Structures must follow{" "}
                <strong>NHB/NHM/BIS-approved</strong> designs and quality norms.
              </li>
              <li>
                <strong>Release Process:</strong> Subsidy disbursed in
                installments after verification by horticulture officials.
              </li>
              <li>
                <strong>Implementation Timeline:</strong> Projects must be
                completed within <strong>12 months</strong> of sanction
                (extensions need prior approval).
              </li>
              <li>
                <strong>Restrictions:</strong> Subsidy cannot be availed from
                multiple schemes for the same project.
              </li>
              <li>
                <strong>Maintenance:</strong> Beneficiaries must maintain the
                structure for at least <strong>5 years</strong>.
              </li>
            </ol>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-8">
            <h2 className="fw-bold mb-3 text-uppercase fs-1">Benefits</h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              These benefits make agricultural projects more sustainable and
              profitable for both small farmers and large agri-startups. By
              reducing financial pressures and promoting modern cultivation
              techniques such as hydroponics and polyhouses, farmers can achieve
              higher productivity with improved crop quality.{" "}
              <b>Kryzen Biotech</b> strengthens this journey by offering expert
              guidance, training programs, and project execution support—helping
              beneficiaries adopt climate-resilient farming and successfully tap
              into both domestic and international markets.
            </p>
            <ol className="fs-2 lh-lg">
              <li>Reduces investment burden on farmers & startups.</li>
              <li>
                Encourages adoption of modern farming like hydroponics,
                polyhouse & protected cultivation.
              </li>
              <li>
                Provides training, workshops & technical guidance for
                sustainable farming.
              </li>
              <li>
                Supports climate-proof farming against erratic monsoons & water
                scarcity.
              </li>
              <li>
                Boosts productivity, crop quality & access to local + export
                markets.
              </li>
            </ol>
          </div>
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/benifits_v6xubk.jpg"
              alt="benefits img"
            />
          </div>
        </div>
        <hr></hr>
        <div className="row mt-7">
          {/* Image Section */}
          <div className="col-12 col-md-5 mt-4 mt-md-0 d-flex justify-content-center align-items-center mb-4 mb-md-0">
            <img
              className="card img-fluid"
              style={{ maxHeight: "500px", width: "100%", objectFit: "cover" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1756358719/shark_tank_uvzuuq.jpg"
              alt="Shark Tank"
            />
          </div>

          {/* Text Section */}
          <div className="col-12 col-md-6 ps-md-2 ms-md-5  text-md-start">
            <h1 className="fw-bold text-uppercase mb-3 fs-1 mt-3 mt-md-0">
              We build best protected farming technology for the world!
            </h1>
            <hr className="mx-auto mx-md-0" />
            <p className="mt-4 fs-2 lh-lg">
              Build a commercially profitable farm anywhere and earn up to
              ₹1,25,000 per month from just 5000 sqft.
            </p>
            <p className="mt-4 fs-2 lh-lg">
              We are top turnkey commercial hydroponics farm project development
              company. We set up hydroponic farms that are low in capex and high
              in returns on investment. With fastest ROI mechanism, We develop
              farm that generates good returns in lowest possible time.
            </p>
          </div>
        </div>
        <div className="row mt-5">
          <h3 className="fs-1 pb-3 text-uppercase">Conclusion</h3>
          <hr></hr>
          <p className="fs-2">
            In conclusion, the <strong>NHB Hydroponic Subsidy</strong> is a
            game-changer for farmers in {state}. Whether you are based in urban
            areas like {city} or agricultural belts like Nashik, the NHB subsidy
            opens doors to future-ready farming that is efficient, scalable, and
            profitable.
          </p>
        </div>
        <div className="row mt-7">
          <div className="row">
            <h2 className="fw-bold text-uppercase mb-3 fs-1">
              Explore NHB Government Subsidy in Other Cities of {state}
            </h2>
            <hr />

            {district.slice(0, 15).map((city, index) => (
              <div key={index} className="col-12 col-md-4 col-lg-4">
                <ul className="fs-3 lh-lg">
                  <li>
                    <a
                      href={`/nhb-government-subsidy/${state}/${city.toLowerCase()}`}
                      className="text-decoration-none text-success"
                    >
                      NHB Government Subsidy in {city}, {state}
                    </a>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-12">
            <img
              className="w-100"
              // style={{height:"380px"}}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844969/footer_jclvvn.jpg"
              alt="footer img"
            ></img>
          </div>
        </div>
      </div>

      <FooterwithoutLogin />
    </div>
  );
};

export default NHBSubsidy;
